// src/components/PreferencesModal/index.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Settings, Bell, Mail, MessageSquare, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from '../LanguageSelector';
import './index.css';
import '../ProfileSectionPage/index.css';

export const PreferencesModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [preferences, setPreferences] = useState({
    notifications: true,
    emailUpdates: true,
    smsAlerts: false
  });

  const handleToggle = (key) => {
    setPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const preferencesList = [
    {
      key: 'notifications',
      icon: Bell,
      label: t('preferences.notifications'),
      description: t('preferences.notificationsDesc')
    },
    {
      key: 'emailUpdates',
      icon: Mail,
      label: t('preferences.emailUpdates'),
      description: t('preferences.emailUpdatesDesc')
    },
    {
      key: 'smsAlerts',
      icon: MessageSquare,
      label: t('preferences.smsAlerts'),
      description: t('preferences.smsAlertsDesc')
    }
  ];

  if (!isOpen) return null;

  return (
    <>
      <div className="profile-section-header">
        <div className="profile-section-header-inner">
          <button
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', padding: 0, marginRight: '15px', display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'var(--color-primary, #ff6b35)' }}
            title="Go Back"
          >
            <ArrowLeft size={28} />
          </button>
          <Settings size={28} />
          <h2>{t('preferences.title')}</h2>
        </div>
      </div>

      <div className="profile-section-content">
        {/* Language Section */}
        <div className="preferences-section">
          <div className="preferences-section-header">
            <h3 className="preferences-section-title">{t('preferences.language')}</h3>
            <p className="preferences-section-desc">Choose your preferred language</p>
          </div>
          <div className="preferences-language-wrapper">
            <LanguageSelector />
          </div>
        </div>

        {/* Notifications Section */}
        <div className="preferences-section">
          <div className="preferences-section-header">
            <h3 className="preferences-section-title">Notifications</h3>
            <p className="preferences-section-desc">Manage how you receive updates</p>
          </div>
          <div className="preferences-list">
            {preferencesList.map(pref => {
              const IconComponent = pref.icon;
              return (
                <div key={pref.key} className={`preference-item ${preferences[pref.key] ? 'active' : ''}`}>
                  <div className="preference-icon-wrapper">
                    <IconComponent size={20} />
                  </div>
                  <div className="preference-info">
                    <strong>{pref.label}</strong>
                    <p>{pref.description}</p>
                  </div>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={preferences[pref.key]}
                      onChange={() => handleToggle(pref.key)}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        <button className="save-preferences-button">
          {t('preferences.savePreferences')}
        </button>
      </div>
    </>
  );
};